import StateConstants from "src/states/StateContstants"
import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler"
import UserFeatureHelper from "src/utils/UserFeatureHelper"

const LOCAL_DEV_FORCED_ACCOUNT_TYPE = "lifetime"

export const LOCAL_DEV_FORCED_FEATURES = [
    UserFeatureHelper.ALL_COMPARABLES,
    UserFeatureHelper.REMOVE_COMPARABLES,
    UserFeatureHelper.DISTANCE_FILTER,
    UserFeatureHelper.PROPERTY_TYPE_FILTER,
    UserFeatureHelper.SALE_RECENCY_FILTER,
    UserFeatureHelper.ALL_TIME_CHART,
    UserFeatureHelper.DETAILED_VALUATIONS,
    UserFeatureHelper.UNLIMITED_DETAILED_VALUATIONS,
    UserFeatureHelper.PRICE_FORECASTING,
    UserFeatureHelper.PDF_REPORT,
]

export function shouldForceLocalDevPremium(): boolean {
    // Disabled: previously forced premium/pro on localhost for testing. Turned off
    // so local dev reflects real (basic) entitlements. (S7 cleanup.)
    return false
}

export function applyUserEntitlements(
    stateHandler: EventAdaptingStateHandler,
    features?: string[] | null,
    accountType?: string | null,
    freeDetailedValuationCreditsRemaining?: number | null,
    freeUnlockedPropertyIds?: string[] | null,
    permissions?: string[] | null,
    role?: string | null
) {
    // Only written when the caller actually knows them. Most call sites predate
    // permissions and pass nothing; treating that as "none" would drop an admin's
    // permissions on login, so absent means leave alone and null means clear.
    if (permissions !== undefined) {
        stateHandler.set(StateConstants.USER_PERMISSIONS, permissions || [])
    }
    if (role !== undefined) {
        stateHandler.set(StateConstants.USER_ROLE, role || null)
    }

    if (shouldForceLocalDevPremium()) {
        stateHandler.set(StateConstants.USER_FEATURES, LOCAL_DEV_FORCED_FEATURES)
        stateHandler.set(StateConstants.ACCOUNT_TYPE, LOCAL_DEV_FORCED_ACCOUNT_TYPE)
        stateHandler.set(StateConstants.IS_PREMIUM, true)
        stateHandler.set(StateConstants.FREE_DETAILED_VALUATION_CREDITS_REMAINING, 0)
        stateHandler.set(StateConstants.FREE_UNLOCKED_PROPERTY_IDS, [])
        return
    }

    const resolvedFeatures = features || []
    const resolvedAccountType = accountType || "basic"
    stateHandler.set(StateConstants.USER_FEATURES, resolvedFeatures)
    stateHandler.set(StateConstants.ACCOUNT_TYPE, resolvedAccountType)
    stateHandler.set(StateConstants.IS_PREMIUM, !["anonymous", "basic"].includes(resolvedAccountType))
    stateHandler.set(
        StateConstants.FREE_DETAILED_VALUATION_CREDITS_REMAINING,
        freeDetailedValuationCreditsRemaining == null ? 0 : freeDetailedValuationCreditsRemaining
    )
    stateHandler.set(
        StateConstants.FREE_UNLOCKED_PROPERTY_IDS,
        Array.isArray(freeUnlockedPropertyIds) ? freeUnlockedPropertyIds : []
    )
}

export function clearUserEntitlements(stateHandler: EventAdaptingStateHandler) {
    if (shouldForceLocalDevPremium()) {
        applyUserEntitlements(stateHandler, [], LOCAL_DEV_FORCED_ACCOUNT_TYPE)
        return
    }

    stateHandler.set(StateConstants.USER_FEATURES, null)
    stateHandler.set(StateConstants.USER_PERMISSIONS, null)
    stateHandler.set(StateConstants.USER_ROLE, null)
    stateHandler.set(StateConstants.IS_PREMIUM, false)
    stateHandler.set(StateConstants.ACCOUNT_TYPE, null)
    stateHandler.set(StateConstants.FREE_DETAILED_VALUATION_CREDITS_REMAINING, null)
    stateHandler.set(StateConstants.FREE_UNLOCKED_PROPERTY_IDS, null)
}
